import React from 'react';
import cn from 'classnames';

import A11y from 'chameleon/ui-stack/utilities/a11y';

const DefaultSortAscIcon = () => (
  <svg
    role="img"
    aria-label="sorted ascending"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.71 12.29L11.3 9.7C11.69 9.31 12.32 9.31 12.71 9.7L15.3 12.29C15.93 12.92 15.48 14 14.59 14H9.41C8.52 14 8.08 12.92 8.71 12.29Z"
      fill="#323232"
    />
  </svg>
);

const DefaultSortDescIcon = () => (
  <svg
    role="img"
    aria-label="sorted descending"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.71 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.41C8.52 10 8.08 11.08 8.71 11.71Z"
      fill="#323232"
    />
  </svg>
);

const DefaultNoSortIcon = () => (
  <svg
    role="img"
    aria-label="not sorted"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8865 6.2925L8.29648 8.8825C7.66648 9.5125 8.10648 10.5925 8.99648 10.5925H14.1765C15.0665 10.5925 15.5165 9.5125 14.8865 8.8825L12.2965 6.2925C11.9065 5.9025 11.2765 5.9025 10.8865 6.2925ZM12.2941 18.3L14.8841 15.71C15.5141 15.08 15.0741 14 14.1841 14H9.00406C8.11406 14 7.66406 15.08 8.29406 15.71L10.8841 18.3C11.2741 18.69 11.9041 18.69 12.2941 18.3Z"
      fill="#2F2F32"
    />
  </svg>
);

const Header = ({
  headerGroups,
  sortAscIcon,
  sortDescIcon,
  noSortIcon,
  rowClassName,
  cellClassName,
  showSortIcon = true,
  aditionalHeaderRows,
}) => {
  const NoSortIcon = noSortIcon || DefaultNoSortIcon;
  const SortAscIcon = sortAscIcon || DefaultSortAscIcon;
  const SortDescIcon = sortDescIcon || DefaultSortDescIcon;

  const renderIconType = (column) => {
    if (column.isSorted) {
      return column.isSortedDesc ? (
        <SortDescIcon columnName={column.id} isSorted />
      ) : (
        <SortAscIcon columnName={column.id} isSorted />
      );
    }
    return column.canSort ? <NoSortIcon columnName={column.id} /> : null;
  };

  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr
          className={cn('', rowClassName)}
          key="temp-overriden-by-headerprops"
          {...headerGroup.getHeaderGroupProps()}
        >
          {headerGroup.headers.map((column) => (
            <th
              key="temp-overriden-by-headerprops"
              className={cn(cellClassName, column.className)}
              {...column.getHeaderProps(column.getSortByToggleProps())}
              title={undefined}
            >
              <A11y>
                <div
                  className={cn('items-center', {
                    'flex flex-row': showSortIcon,
                    'float-right': column.floatRight,
                    'justify-center': column.centered,
                  })}
                  {...(column.canSort
                    ? {
                        role: 'button',
                        tabIndex: '0',
                      }
                    : {})}
                >
                  <div>{column.render('Header')}</div>
                  {showSortIcon && column.showIcon !== false && (
                    <div className="ml-4">{renderIconType(column)}</div>
                  )}
                </div>
              </A11y>
            </th>
          ))}
        </tr>
      ))}
      {/* Expect to receive additional tr elements that shouldn´t affect the default behavior of the table (Sorting, Filtering, etc) */}
      {aditionalHeaderRows}
    </thead>
  );
};

export default Header;
